<template>
  <div style="background: #1f1c1f;">
    <div class="header" >
      <div class="header_content">
        
        <div v-if="!hasToken" @click="toLogin('/Register')">{{$t("auth.register")}}</div>
        <div v-else></div>
        <div class="img_c" style="color: #e6b98a;">
          {{$t("q30")}}
        </div>
        <div class=""></div>
        <!-- <div style="display: flex; " v-if="!hasToken" @click="toLogin('/Login')">
          <van-icon name="chat-o" color="#f3c7a2" size="24" />
          {{$t("auth.login")}}
        </div>
        <div v-else @click="toLogin('/ServiceOnline')">
          <van-icon name="chat-o" color="#f3c7a2" size="24" />
        </div> -->
      </div>
    </div>
    
    
    <div class="tu_list">
      <div class="tu_item" v-for="item in datalist" :key="item.id"  @click="toDetail(item.id)">
        <div class="renzh">{{$t("q31")}}</div>
        <div class="info_box">
          <div class="c_id">{{ item.xuanfei_name }}</div>
          <!-- <div class="c_c">{{ item.xuanfei_name }}</div> -->
          <div class="c_c">{{$t("index.height")}}: {{item.hight}}cm</div>
          <div class="c_c">{{$t("index.bust")}}：{{ item.bust }}</div>
          <div class="c_c">{{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}</div>
          <div class="c_b_k">
            <img src="/img/neww/icon_views.png" class="sm_in">
            <span>{{item.chakan}}</span>
            <img src="/img/neww/icon_love.png" class="sm_in cc">
            <span>{{item.dianzan}}</span>
          </div>
        </div>
        <img :src="item.img_url" class="sm_in_c van-image__img"
        style="object-fit: cover;">
      </div>
    </div>
    <!-- <div style="padding: 10px;">
      <div style="font-size: 16px;">{{$t("index.recommend")}}</div>
      <div>
        <div class="horizontalItem" v-for="item in datalist" :key="item.id"  @click="toDetail(item.id)">
          <div  class="imgBox">
            <div
              
              class="van-image"
              style="
                width: 120px;
                height: 120px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="item.img_url"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
            <span ><i>{{$t("concubine.high_end")}}</i></span>
          </div>
          <div  style="width: calc(100% - 140px);">
            <div  class="top">
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    style="width: 13px; height: 13px;"
                    class="van-image__img"
                  />
                </div>
                <span >{{$t("index.authentication")}}</span>
              </div>
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    class="van-image__img"
                    style="width: 13px; height: 13px;"
                  />
                </div>
                <span >{{$t("index.video_authentication")}}</span>
              </div>
              <div
                
                style="
                  width: 70px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
               {{ item.xuanfei_name }}
              </div>
            </div>
            <div  class="tags">
              <van-tag
        v-for="(tag, index) in item.flagArray"
        :key="index"
        :type="tagTypes[index]"
      >
        {{ tag }}
      </van-tag>
              
            </div>
            <div  style="display: flex; align-items: center;">
              <span
                
                style="font-size: 14px; color: rgb(102, 102, 102);"
                >{{$t("index.toll")}}：</span
              >
              <van-rate v-model="item.number"   color="#ffd21e" size="20px" />
            </div>
            <div
              
              style="
                color: rgb(153, 153, 153);
                font-size: 12px;
                margin: 5px 0px;
              "
            >
            {{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }} {{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}
            </div>
            <div  class="yueta">{{$t("index.about")}}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div
      style="
        background: linear-gradient(rgb(254, 89, 134), rgb(255, 132, 139));
        width: 96%;
        margin: 0px auto 30px;
        border-radius: 8px;
        overflow: hidden;
        padding-bottom: 10px;
      "
    >
      <div
        style="
          color: rgb(255, 232, 105);
          text-align: center;
          padding: 10px 0px;
        "
      >
        {{$t("online.matching")}}
      </div>
      <div class="OnlineMatching">
   
        <div
          :style="{
            transform: `translate(0px, ${translateY}px)`,
            transition: 'transform 1s ease-in',
          }"
          ref="scrollContainer"
        >
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ {{$t("online.joined")}}</li>
              <li>しらつちのりこ {{$t("online.joined")}}</li>
              <li>はくやすのり {{$t("online.joined")}}</li>
              <li>はくやすのり {{$t("online.joined")}}</li>
              <li>ふちれいこ {{$t("online.joined")}}</li>
              <li>ちのなな {{$t("online.joined")}}</li>
              <li>ちのなな {{$t("online.joined")}}</li>
              <li>たけじかずのぶ {{$t("online.joined")}}</li>
              <li>たけじかずのぶ {{$t("online.joined")}}</li>
              <li>ふちれいこ {{$t("online.joined")}}</li>
            </ul>
          </div>
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ {{$t("online.joined")}}</li>
              <li>しらつちのりこ {{$t("online.joined")}}</li>
              <li>はくやすのり {{$t("online.joined")}}</li>
              <li>はくやすのり {{$t("online.joined")}}</li>
              <li>ふちれいこ {{$t("online.joined")}}</li>
              <li>ちのなな {{$t("online.joined")}}</li>
              <li>ちのなな {{$t("online.joined")}}</li>
              <li>たけじかずのぶ {{$t("online.joined")}}</li>
              <li>たけじかずのぶ {{$t("online.joined")}}</li>
              <li>ふちれいこ {{$t("online.joined")}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed:800,
        autoplay:true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows : true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning']
    };
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        console.log(this.basicData,"309");
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
      console.log(res,11)
      });
    },
    getBanner(data){
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str});
    },
    getNotice(data){
      this.notice = data.notice;
    },
    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;

        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      // 可选：在组件销毁时清除定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
         console.log(lanng)
        this.datalist = res.data;
        this.datalist.forEach(item => {
          const parts = item.flag.split('|')
          if(parts.length === 1){
            item.flag = parts[0];
          }else{
            lanng == 'zh'? item.flag = parts[0]:lanng == 'en'? item.flag = parts[1]: lanng == 'ja'?item.flag = parts[2]:item.flag = parts[3]
          }
          item.flagArray = item.flag.split('，');
          if(item.xuanfei_name){
            const nameParts = item.xuanfei_name.split('|');
            if(nameParts.length === 1){
              item.xuanfei_name = nameParts[0];
            }else{
              item.xuanfei_name = lanng == 'zh' ? nameParts[0] : lanng == 'en' ? nameParts[1] : lanng == 'ja' ? nameParts[2] : nameParts[3];
            }
          }
        })
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
        console.log(this.groupedData);
        console.log(res.data);
      });
    },
  },

  mounted() {
    if(this.$refs.scrollContainer){
      this.containerHeight = this.$refs.scrollContainer.clientHeight;
      this.startAnimation();
    }
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery()
  },
};
</script>

<style lang="less" scoped>
.tu_list{
  padding-top: 100px;
  .tu_item{
    margin: 26px 20px 16px;
    border-radius: 16px;
    padding: 30px 40px 30px 26px;
    background: linear-gradient(120deg,#212121,#313131);
    border: 1px solid #766350;
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    .renzh{
      position: absolute;
      right: -80px;
      top: 42px;
      font-size: 24px;
      padding: 1px 59px;
      font-style: normal;
      transform: rotate(45deg);
      background: linear-gradient(90deg, #efcba7, #dcab76);
      color: #000000;
    }
    .sm_in_c{
      width: 186px;
      height: 186px;
      border-radius: 50%;
    }
    .info_box{
      .c_id{
        width: 200px;
        text-align: center;
        background-color: #fff;
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #8d5825;
        border-radius: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .c_c{
        color: #ddd;
        font-size: 26px;
        padding-top: 10px;
      }
      .c_b_k{
        display: flex;
        align-items: center;
        color: #666;
        font-size: 22px;
        padding-top: 16px;
        .sm_in{
          width: 30px;
          height: 30px;
          &.cc{
            margin-left: 16px;
          }
        }
      }
    }
  }
}
.nav_box{
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  .x_p{
    text-align: center;
    color: #e6b98a;
    img{
      height: 76px;
    }
  }
}
.put_tit{
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  &::before{
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background-color: #e6b98a;
    left: 0;
    top: 6px;
  }
}
.wuzii{
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  border: 1px solid #766350;
  .xx_bc{
    display: flex;
    flex-wrap: wrap;
    font-size: 26px;
    color: #ccc;
    justify-content: space-between;
    padding-top: 10px;
    .top_link{
      padding: 20px 10px;
    }
  }
}
.wuzii_p{
  margin: 26px 20px 16px;
  background: linear-gradient(120deg,#212121,#313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;
  .xx_bc_u{
    color: #ccc;
  }
}
.header {
  height: 13vw;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  background-color: #1f1c1f;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;

  .img {
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 16px;
  border: 1px solid #766350;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}

.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}
</style>
